export { ProductMediaAlt } from './ProductMediaAlt';
